export default {
  // 获取走进jnc
  GET_LIST: '/jcnapi/slide/getList',
  DEL: '/jcnapi/slide/delete',
  //保存
  SAVE: '/jcnapi/slide/save',
  GET: '/jcnapi/slide/getInfo',
  SAVE_HOME_PAGE: '/jcnapi/homepage/save',
  GET_HOME_PAGE: '/jcnapi/homepage/get'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/slide/index.js